module.exports = __webpack_public_path__ + "static/media/icon7.e6e27923.svg";